import axios from 'axios';
import useSWR from 'swr';

const useFeatureUsage = (filters = {}) => {
  const searchParams = new URLSearchParams();

  if (filters.startDate) {
    const startOfDay = new Date(filters.startDate + 'T00:00:00.000');
    searchParams.set('startTsGte', startOfDay.toISOString());
  }
  if (filters.endDate) {
    const endOfDay = new Date(filters.endDate + 'T23:59:59.999');
    searchParams.set('startTsLte', endOfDay.toISOString());
  }

  const url = `/admin/company/feature-usage?${searchParams.toString()}`;

  const swr = useSWR(url, async (url) => {
    try {
      const result = await axios.get(url);
      return result.data;
    } catch (err) {
      throw Error(err);
    }
  });

  return swr;
};

export { useFeatureUsage };
